import {translations} from 'presentation/translations-new';
import * as z from 'zod';
import {ALLOWED_EXTENSIONS, MAX_SIZE_FILE_IN_BYTES} from './constants';

const {maxSizeFile, invalidTypeFile} = translations['pt-br'].others.uploadFiles.validations;

export const SendingFilesSchema = z.custom<File>().superRefine((val, ctx) => {
	if (!(val instanceof File)) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: invalidTypeFile,
		});
		return;
	}

	const allowedExtensions = ALLOWED_EXTENSIONS.map(extension => extension.slice(1));

	const fileExtensionFormatted = val.name.split('.').pop()?.toLowerCase();
	if (!fileExtensionFormatted || !allowedExtensions.includes(fileExtensionFormatted)) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: invalidTypeFile,
		});
	}

	if (val.size > MAX_SIZE_FILE_IN_BYTES) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: maxSizeFile,
		});
	}
});

export type SendingFilesValues = z.infer<typeof SendingFilesSchema>;
